import { render, staticRenderFns } from "./CourseSlotLogs.vue?vue&type=template&id=60ca1221&"
import script from "./CourseSlotLogs.vue?vue&type=script&lang=js&"
export * from "./CourseSlotLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports